<template>
    <div v-if="! updating" :id="null">
        <select :value="value" class="form-control select" ref="select" :id="id">
            <slot></slot>
            <option v-for="opt in options" :value="opt.id" :selected="isSelected(opt)">{{ opt.text }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            autoUpdateOptions: {
                type: Boolean,
                default: false
            },
            options: {
                default: () => ([])
            },
            value: {
                default: () => ''
            },
            id: {
                default: () => ''
            },
            disabled: Boolean,
        },
        data() {
            return {
                model: '',
                updating: false,
            }
        },
        methods: {
            /**
             * Handle change events.
             */
            handleChange() {
                $(this.$refs.select).on('select2:select', (e) => {
                    let value = $(e.currentTarget).val();
                    this.model = value;
                });
            },

            /**
             * Determine if option is selected.
             *
             * @param {string} opt
             */
            isSelected(opt) {
                return (opt.id == this.model);
            },

            /**
             * Toggle disable.
             *
             * @param disabled
             */
            toggleDisabled(disabled) {
                $(this.$refs.select).prop('disabled', disabled);
            },

            /**
             * Update the options.
             */
            updateOptions() {
                this.updating = true;

                this.$nextTick(() => {
                    this.updating = false;

                    this.$nextTick(() => {
                        this.handleChange();

                        this.$nextTick(() => {
                            this.toggleDisabled(this.disabled);
                        });
                    });
                });
            }
        },
        mounted() {
            this.model = this.value;
            this.handleChange();

            if (this.disabled) {
                this.$nextTick(() => {
                    this.toggleDisabled(true);
                });
            }
        },
        destroyed() {
            $(this.$refs.select).off('select2:select')
                .off('change.select2');
        },

        watch: {
            model (model) {
                this.$emit('input', model);
                $(this.$refs.select).val(model).trigger('change.select2');
            },

            value (value) {
                this.model = value;
            },

            disabled( disabled) {
                this.$nextTick(() => {
                    this.toggleDisabled(disabled);
                });
            },

            options (options) {
                if (this.autoUpdateOptions && ! this.updating) {
                    this.updateOptions();
                }
            },
        }
    }
</script>